import {
  GMB_AGGREGATED_API,
  GMB_REVIEWS_API,
  SITE_DOMAIN,
} from "../constants/gmb";
import { normalizeGmbReview } from "../utils/gmbReviewHelpers";

async function postGmbApi(url, body) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 15000);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`GMB API request failed with status ${response.status}`);
    }

    const payload = await response.json();

    if (payload.status !== 200) {
      throw new Error(`GMB API returned status ${payload.status}`);
    }

    return payload;
  } finally {
    clearTimeout(timeoutId);
  }
}

export async function fetchAggregatedGmbReviews(domain = SITE_DOMAIN) {
  const payload = await postGmbApi(GMB_AGGREGATED_API, { domain });

  return {
    aggregateRating: payload.aggregateRating,
    ratingCount: payload.ratingCount,
  };
}

export async function fetchGmbReviews({
  domain = SITE_DOMAIN,
  pageSize = "20",
} = {}) {
  const payload = await postGmbApi(GMB_REVIEWS_API, {
    domain,
    page_size: String(pageSize),
  });

  const locationReviews = payload.data?.locationReviews || [];

  return locationReviews.map(normalizeGmbReview);
}
